import { useEffect, useState } from "react";
import { getPricebookBranches } from "../../../../services";
import { PricebookBranches } from "../../../../types/price-book.type";

/**
 * Where the book is open and how many shops each branch has on it — read once per book and
 * shared by the สาขาที่ใช้ card, the ร้านค้าตามสาขา tab and the branch dialog, which hands
 * back the saved answer through `setBranches`.
 */
export function usePricebookBranches(pricebookUuid: string) {
  const [branches, setBranches] = useState<PricebookBranches | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    let ignore = false;
    setLoading(true);

    const load = async () => {
      try {
        const {
          data: { data },
        } = await getPricebookBranches(pricebookUuid);
        if (!ignore) setBranches(data);
      } catch {
        // The axios interceptor shows the failure; the card and the tab say nothing is loaded.
        if (!ignore) setBranches(null);
      } finally {
        if (!ignore) setLoading(false);
      }
    };

    load();
    return () => {
      ignore = true;
    };
  }, [pricebookUuid]);

  return { branches, loading, setBranches };
}
